// extracted by mini-css-extract-plugin
module.exports = {"tourName":"ScreenStatus_tourName__2Y_7f","tourLanguage":"ScreenStatus_tourLanguage__28B57"};